module.exports = __webpack_public_path__ + "img/promo-5-mock.794b369c.png";